import { Link } from 'react-router-dom';
import { EmptyState } from '../components/ui';

export function NotFoundPage() {
  return (
    <EmptyState title="Page not found">
      <p>That page does not exist, or it has moved.</p>
      <p style={{ marginBottom: 0 }}>
        <Link to="/">Back to the event details</Link>
      </p>
    </EmptyState>
  );
}
